import Block from "domain/Block";

export default function openModal({ onOpenCreateBlock, onOpenEditDowntime, onOpenEditWorkBlock }) {
  return ({ eventRecord, resourceRecord }) => {
    const blockData = eventRecord.data;

    blockData.endDate = eventRecord.endDate;
    blockData.startDate = eventRecord.startDate;

    switch (Block.type(blockData.block)) {
      case "WorkBlock":
        openBlockModal({ blockData, eventRecord, open: onOpenEditWorkBlock, resourceRecord });
        break;
      case "DowntimeBlock":
        openBlockModal({ blockData, eventRecord, open: onOpenEditDowntime, resourceRecord });
        break;
      default:
        openBlockModal({
          blockData: { ...blockData, id: undefined },
          eventRecord,
          open: onOpenCreateBlock,
          resourceRecord,
        });
    }

    return false;
  };
}

function openBlockModal({ blockData, resourceRecord, open, eventRecord }) {
  open({
    ...blockData,
    block: {
      ...blockData.block,
      line: resourceRecord.data,
    },
    eventRecord,
  });
}
